module.exports = __webpack_public_path__ + "static/img/produtos_g.453b104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/mate/produtos_g.png
// module id = gKGT
// module chunks = 0